import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionsWrapper } from "./ui";
import { useSectionObserver, useTestId } from "@/hooks";
import { Hardfacts } from "@/components/Sections/Hardfacts";
import { Address, LocationLazy } from "@/components/Sections/Location";
import { Energy } from "@/components/Sections/Energy";
import { ClassifiedKeys } from "@/components/Sections/ClassifiedKeys";
import { Price } from "@/components/Sections/Price";
import { PropertyProvider } from "@/components/Sections/PropertyProvider";
import { MortgageEstimation } from "@/components/Sections/Mortgage";
import { Documents } from "@/components/Sections/Documents";
import { PartnerBoxCommercial, PartnerBoxServices, } from "@/ads/components/PartnerBox";
import { Features } from "@/components/Sections/Features";
import { SellerLeadTeaser } from "@/components/Sections/SellerLeadTeaser";
import { Sponsor } from "@/components/Sections/Sponsor";
import { SeoH1Wrapper } from "@/components/Sections/HeadingSEO";
import { RichMedias } from "@/components/Sections/RichMedias";
import { ContactCard } from "@/components/Sections/ContactCard/ContactCard";
import { NewBuild } from "@/components/Sections/NewBuild";
import { PriceComparison } from "@/components/Sections/PriceComparison";
import { AdditionalDescription } from "@/components/Sections/Description/AdditionalDescription";
import { MainDescription } from "@/components/Sections/Description/MainDescription";
import { Floorplan } from "@/components/Sections/Floorplan";
import { GeoRisk } from "@/components/Sections/GeoRisk";
import { BottomContactOpenedForm } from "../contacting/ContactOpenedForm/BottomContactOpenedForm";
import { CoOwnership } from "@/components/Sections/CoOwnership/CoOwnership";
export const Sections = () => {
    const testId = useTestId("Sections.Wrapper");
    useSectionObserver();
    return (_jsxs(SectionsWrapper, { testId: testId, children: [_jsxs(SeoH1Wrapper, { children: [_jsx(Hardfacts, {}), _jsx(Address, { isLink: true })] }), _jsx(ContactCard, {}), _jsx(NewBuild, {}), _jsx(Sponsor, {}), _jsx(MainDescription, {}), _jsx(PartnerBoxCommercial, {}), _jsx(Features, {}), _jsx(Floorplan, {}), _jsx(RichMedias, {}), _jsx(LocationLazy, {}), _jsx(Energy, {}), _jsx(Price, {}), _jsx(CoOwnership, {}), _jsx(SellerLeadTeaser, {}), _jsx(PriceComparison, {}), _jsx(MortgageEstimation, {}), _jsx(AdditionalDescription, {}), _jsx(PartnerBoxServices, {}), _jsx(GeoRisk, {}), _jsx(BottomContactOpenedForm, {}), _jsx(PropertyProvider, {}), _jsx(Documents, {}), _jsx(ClassifiedKeys, {})] }));
};
